export enum MonitoringQuotaTypesEnum {
    MEDIA_SUBSCRIPTION = 'SOCIAL_SUBSCRIPTION',
    SOCIAL_LISTENING = 'SOCIAL_TOPIC'
}
